import { render, staticRenderFns } from "./DocumentosDelegacionTable.vue?vue&type=template&id=d311b8ce&scoped=true"
import script from "./DocumentosDelegacionTable.vue?vue&type=script&lang=ts"
export * from "./DocumentosDelegacionTable.vue?vue&type=script&lang=ts"
import style0 from "./DocumentosDelegacionTable.vue?vue&type=style&index=0&id=d311b8ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d311b8ce",
  null
  
)

export default component.exports